import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password-show",
  "use": "icon-password-show-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-password-show\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M12 7c-3.333 0-6.18 2.073-7.333 5 1.153 2.927 4 5 7.333 5s6.18-2.073 7.333-5c-1.153-2.927-4-5-7.333-5zm0 8.333a3.335 3.335 0 0 1 0-6.666 3.335 3.335 0 0 1 0 6.666zM12 10c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2-.893-2-2-2z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol